
import { Component, Prop, Vue } from "vue-property-decorator";

import CustomisedRequestCard from "@/components/card/CustomisedRequestCard.vue";
import CollapsibleDescription from '@/components/common/CollapsibleDescription.vue';
import CardBodyItem from "@/components/card/CardBodyItem.vue";
import CardBodyItemSkill from "@/components/card/CardBodyItemSkill.vue";

import ItemChipsWithMore from "@/components/common/ItemChipsWithMore.vue";
import Badge from "@/components/common/Badge.vue";
import CustomRequestModal from "@/components/requests/CustomRequestModal.vue";
import CustomRequestActions from "@/components/requests/CustomRequestActions.vue";

import { getStatusName } from "@/helpers/requests/getStatus";
import getFullName from "@/helpers/getFullName";
import { NO_INFORMATION } from '@/data/placeholders';
import {
  Custom_Request,
  Custom_Request_Skills,
  Skill,
  User, Tag
} from "@/generated/graphql";
import RouteNames from "@/entities/RouteNames";
import RouteParams from "@/entities/RouteParams";
import { CustomRequestStatus } from "@/entities/CustomRequestStatus";
import BadgeColor from "@/entities/BadgeColor";
import { customRequestSkillsNumber } from "@/data/skillChipsNumber";
import CollapsibleDescriptionLength from "@/entities/CollapsibleDescriptionLength";
import SuitableResources from "@/components/requests/SuitableResources.vue";
import S3Image from "@/components/common/s3-image.vue";
import ChipsWithMore from "@/components/common/ChipsWithMore.vue";
import ChipWithLinkData from "@/types/ChipWithLinkData";


@Component({
  components: {
    SuitableResources,
    CustomisedRequestCard,
    CollapsibleDescription,
    CardBodyItem,
    CardBodyItemSkill,
    S3Image,
    ItemChipsWithMore,
    Badge,
    CustomRequestModal,
    CustomRequestActions,
    ChipsWithMore
  },
})

export default class CustomRequestCard extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly skills!: Custom_Request_Skills[];
  @Prop({ type: Object, required: true }) readonly request!: Custom_Request;
  @Prop({ type: Object, required: true }) readonly createdBy!: User;
  @Prop({ type: Boolean, required: true }) readonly isAdmin!: boolean;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: String, default: "h-6 w-6" }) readonly avatarClasses!: string;
  @Prop({ type: Boolean, default: false }) readonly highlightAvatar!: boolean;

  modalShown = false;
  collapsibleDescriptionLength = CollapsibleDescriptionLength;
  skillsNumber = customRequestSkillsNumber;

  get skillIds(): number[] {
    return this.requestSkills.map(({ id }: Skill) => id);
  }


  get excludeResourceUserId(): string {
    return this.request.project_activity?.contractor?.user_id;
  }

  get requestJobTitle(): string {
    return this.request.job_title || NO_INFORMATION;
  }
  get requestTagname(): Tag {
    //@ts-ignore
    return this.request.tag?.name || NO_INFORMATION;
  }

  get requestDescription(): string {
    return this.request.description || NO_INFORMATION;
  }


  message(): void {
    // var recipientId = null;
    // var currentUser:User = Vue.prototype.$currentUser;
    // if(currentUser.role === 'ADMIN') {
    //   recipientId = this.createdBy.id;
    // } else {
    //   recipientId = this.request?.company?.admins[0]?.user.id;
    // }
    // this.$router.push({
    //   name: RouteNames.INBOX,
    //   query: {
    //     recipientUserId: recipientId,
    //   },
    // });
    this.$router.push({
      name: RouteNames.REQUEST_CONVERSATIONS,
      params: {
        id: this.request.id,
      },
    });
  }

  get badgeColor(): string {
    switch (this.request.status) {
      case CustomRequestStatus.UNDER_REVIEW:
        return BadgeColor.INFO;
      case CustomRequestStatus.APPLICANTS_SENT:
        return BadgeColor.WARNING;
      default:
        return BadgeColor.SUCCESS;
    }
  }

  get requestSkills(): Skill[] {
    return this.skills.map(({ skill }) => skill);
  }

  get requestSkills2(): ChipWithLinkData[] {
    let skills = this.skills.map(({ skill }) => skill);
    const skillss = skills.reduce(function (filtered, skill) {
      let chipWithLinkData: ChipWithLinkData = {
        variant: "blue",
        chipLink: {},
        chipData: { id: skill.id.toString(), name: skill.name },
        avatar: "",
        chipText: ""
      };
      filtered.push(chipWithLinkData);
      return filtered;
    }, []);
    // skills.sort((a, b) => a.variant.localeCompare(b.variant));
    return skillss;
  }

  get requestCreatorName(): string {
    const createdBy = this.request.created_by;
    return getFullName(createdBy.given_name!, createdBy.family_name!);
  }
  get requestTagName(): Tag {
    const createdBy = this.request.tag_id;
    return createdBy.name;
  }
  get createdByCurrentUser(): boolean {
    return this.request.created_by.id === this.currentUserId;
  }

  get requestCreatorLink(): RouteParams<{ id: string }> | undefined {
    const managerId = this.request.created_by.manager?.id;
    if (!managerId) {
      return undefined;
    }
    return {
      name: (RouteNames.MANAGER_ABOUT),
      params: { id: managerId }
    }
  }

  // get requestCLink(): RouteParams<{ id: string }> | undefined {
  //   const managerId = this.request.created_by.manager?.id;
  //   if (!managerId) {
  //     return undefined;
  //   }
  //   return {
  //     name: (RouteNames.REQUESTS ),
  //     params: { id: managerId }
  //   }
  // }

  get requestLink(): RouteParams<{ id: string }> | undefined {
    const requestId = this.request.id;
    if (!requestId) {
      return undefined;
    }
    return {
      name: (RouteNames.CUSTOM_REQUESTS_RESOURCES_SUGGESTED),
      params: { id: requestId }
    }
  }

  get status(): string {
    return getStatusName(this.request.status);
  }

  toggleRequestModal(): void {
    this.modalShown = !this.modalShown;
  }

  handleRefetch(): void {
    this.$emit("refetch");
  }

  transformDate(dateToChange: string): string {
    let yourDate = new Date(dateToChange);
    const offset = yourDate.getTimezoneOffset()
    yourDate = new Date(yourDate.getTime() - (offset * 60 * 1000))
    return yourDate.toISOString().split('T')[0]
    // return new Date(dateToChange).toISOString().split('T')[0];
  }
  get defaultInitialsClasses(): string {
    return "inline-flex h-6 w-6 rounded-full items-center justify-center";
  }
  get bgStyle(): object {
    return {
      background: "#1c64f2",
    };
  }
  get avatarStyleClasses(): Record<string, boolean> {
    return {
      [this.avatarClasses]: Boolean(this.avatarClasses),
      ["border border-primary"]: this.highlightAvatar,
    };
  }
  get defaultImageClasses(): string {
    return "inline-block rounded-full object-cover object-center";
  }
}
